export const deckDifficulty: { [key: string]: { difficulty: number; reason: string } } = {
  "abzan-armor": {
    difficulty: 6,
    reason: "Balanced complexity with accessible gameplay and fun interactions."
  },
  "adaptive-enchantment": {
    difficulty: 6,
    reason: "Balanced complexity with accessible gameplay and fun interactions."
  },
  "ahoy-mateys": {
    difficulty: 6,
    reason: "Pirates and treasure create fun, aggressive gameplay."
  },
  "anikthea": {
    difficulty: 7,
    reason: "Enchantment creatures create unique board states to manage."
  },
  "animated-army": {
    difficulty: 7,
    reason: "Turning non-creatures into creatures requires tracking unusual board states."
  },
  "arcane-maelstrom": {
    difficulty: 8,
    reason: "Intricate mechanics that reward careful play and planning."
  },
  "arcane-wizardry": {
    difficulty: 9,
    reason: "Advanced strategies with multiple decision points. Best for experienced players."
  },
  "atog-feast": {
    difficulty: 6,
    reason: "Balanced complexity with accessible gameplay and fun interactions."
  },
  "aura-of-courage": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "bear-force-one": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "blame-game": {
    difficulty: 5,
    reason: "Goad is simple to understand and creates fun political dynamics."
  },
  "blast-from-the-past": {
    difficulty: 8,
    reason: "Suspend and time counters add complexity but create explosive turns."
  },
  "blood-rites": {
    difficulty: 6,
    reason: "Vampire tribal with lifedrain is classic and easy to pilot."
  },
  "breed-lethality": {
    difficulty: 9,
    reason: "Advanced strategies with multiple decision points. Best for experienced players."
  },
  "built-from-scratch": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "call-the-spirits": {
    difficulty: 6,
    reason: "Balanced complexity with accessible gameplay and fun interactions."
  },
  "carnival-of-souls": {
    difficulty: 7,
    reason: "Intricate mechanics that reward careful play and planning."
  },
  "cavern-critters": {
    difficulty: 6,
    reason: "Descend mechanic creates interesting graveyard gameplay."
  },
  "cephalid-experiment": {
    difficulty: 5,
    reason: "Balanced complexity with accessible gameplay and fun interactions."
  },
  "chaos-incarnate": {
    difficulty: 8,
    reason: "Four-color mana base and aggressive cascade create challenging gameplay."
  },
  "collector-ouphe": {
    difficulty: 6,
    reason: "Enchantment synergies are intuitive once you understand constellation."
  },
  "counter-blitz": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "counter-intelligence": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "counterpunch": {
    difficulty: 9,
    reason: "Advanced strategies with multiple decision points. Best for experienced players."
  },
  "creative-energy": {
    difficulty: 7,
    reason: "Energy management and timing creature copies needs practice but is rewarding."
  },
  "deadly-disguise": {
    difficulty: 7,
    reason: "Morph and disguise add hidden information that requires practice to leverage well."
  },
  "death-toll": {
    difficulty: 6,
    reason: "Mill and reanimate is a classic graveyard strategy that's easy to learn."
  },
  "deep-clue-sea": {
    difficulty: 5,
    reason: "Clue tokens are simple to understand and provide consistent card advantage."
  },
  "desert-bloom": {
    difficulty: 6,
    reason: "Land-based strategies are straightforward with clear goals and payoffs."
  },
  "devour-for-power": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "dinosaur-empire": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "doctor-who-masters": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "doctor-who-paradox": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "draconic-domination": {
    difficulty: 7,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "draconic-rage": {
    difficulty: 6,
    reason: "Balanced complexity with accessible gameplay and fun interactions."
  },
  "eldrazi-incursion": {
    difficulty: 7,
    reason: "Requires managing colorless mana and expensive spells, but rewards with overwhelming power."
  },
  "elemental-fury": {
    difficulty: 9,
    reason: "Advanced strategies with multiple decision points. Best for experienced players."
  },
  "elven-council": {
    difficulty: 6,
    reason: "Elf tribal with some counters and drawing - classic and approachable."
  },
  "endless-punishment": {
    difficulty: 6,
    reason: "Punisher effects are simple but require patience as damage accumulates slowly."
  },
  "entropic-uprising": {
    difficulty: 9,
    reason: "Advanced strategies with multiple decision points. Best for experienced players."
  },
  "eternal-bargain": {
    difficulty: 7,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "eternal-might": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "evasive-maneuvers": {
    difficulty: 9,
    reason: "Advanced strategies with multiple decision points. Best for experienced players."
  },
  "explorers-of-the-deep": {
    difficulty: 5,
    reason: "Explore mechanic is simple and rewards you for playing creatures."
  },
  "exquisite-invention": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "faceless-menace-2019": {
    difficulty: 6,
    reason: "Balanced complexity with accessible gameplay and fun interactions."
  },
  "faerie-schemes": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "family-matters": {
    difficulty: 6,
    reason: "Token copying is intuitive once you understand which creatures to copy."
  },
  "feline-ferocity": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "food-and-fellowship": {
    difficulty: 5,
    reason: "Food tokens and lifegain create a friendly, easy-to-pilot deck."
  },
  "forces-of-the-imperium": {
    difficulty: 6,
    reason: "Soldier tribal with anthem effects is easy to understand."
  },
  "forged-in-stone": {
    difficulty: 6,
    reason: "Balanced complexity with accessible gameplay and fun interactions."
  },
  "fortnite-1": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "fortress-defense": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "fungus-forest": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "goblin-gang": {
    difficulty: 7,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "godzilla-1": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "grand-larceny": {
    difficulty: 7,
    reason: "Playing with opponents' cards is unique but requires reading and understanding unfamiliar effects."
  },
  "graveyard-overdrive": {
    difficulty: 6,
    reason: "Graveyard strategies are intuitive once you understand the basic loop of filling and recurring."
  },
  "guided-by-nature": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "hail-caesar": {
    difficulty: 6,
    reason: "Aristocrats strategies are intuitive - create tokens, sacrifice them, profit."
  },
  "heavenly-host": {
    difficulty: 7,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "heavenly-inferno": {
    difficulty: 7,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "horse-parade": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "hosts-of-mordor": {
    difficulty: 6,
    reason: "Straightforward aggressive strategy with iconic Lord of the Rings characters."
  },
  "hydra-growth": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "insect-swarm": {
    difficulty: 7,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "invent-superiority": {
    difficulty: 9,
    reason: "Advanced strategies with multiple decision points. Best for experienced players."
  },
  "jeskai-striker": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "jump-scare": {
    difficulty: 7,
    reason: "Morph creates hidden information that takes practice to leverage."
  },
  "jurassic-world-1": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "kithkin-community": {
    difficulty: 3,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "limit-break": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "living-energy": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "lorehold-legacies": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "mardu-surge": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "masters-of-evil": {
    difficulty: 7,
    reason: "Villain tribal with various abilities requires understanding different triggers."
  },
  "merciless-rage": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "merfolk-seaside": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "mind-seize": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "minotaur-herd": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "miracle-worker": {
    difficulty: 7,
    reason: "Top-deck manipulation and miracles require careful planning."
  },
  "mirror-mastery": {
    difficulty: 7,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "monty-python-1": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "moonfolk-ascension": {
    difficulty: 6,
    reason: "Balanced complexity with accessible gameplay and fun interactions."
  },
  "most-wanted": {
    difficulty: 5,
    reason: "Tribal strategies are simple - just play your creature types and reap rewards."
  },
  "mutant-menace": {
    difficulty: 7,
    reason: "Mill and rad counters offer unique gameplay that takes practice to optimize."
  },
  "myr-matrix": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "mystic-intellect": {
    difficulty: 6,
    reason: "Balanced complexity with accessible gameplay and fun interactions."
  },
  "natures-vengeance": {
    difficulty: 7,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "natures-vengeance-2018": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "necron-dynasties": {
    difficulty: 7,
    reason: "Artifacts with graveyard synergies require tracking multiple zones."
  },
  "ninja-strike": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "ommodore-guff": {
    difficulty: 8,
    reason: "Managing multiple planeswalkers and protecting them requires advanced planning."
  },
  "ooze-experiment": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "open-hostility": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "pantlaza": {
    difficulty: 6,
    reason: "Discover is straightforward and finds you big dinosaurs."
  },
  "paradox-power": {
    difficulty: 7,
    reason: "Historic matters and artifacts create interesting but manageable complexity."
  },
  "party-time": {
    difficulty: 6,
    reason: "Party mechanic rewards diverse creature types in a fun way."
  },
  "peace-offering": {
    difficulty: 6,
    reason: "Group hug requires political skills but the mechanics are simple."
  },
  "peer-through-time": {
    difficulty: 9,
    reason: "Advanced strategies with multiple decision points. Best for experienced players."
  },
  "phoenix-rebirth": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "phyrexian-swarm": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "planar-genesis": {
    difficulty: 5,
    reason: "Populate is simple - copy your best token repeatedly."
  },
  "planeswalker-party": {
    difficulty: 8,
    reason: "Intricate mechanics that reward careful play and planning."
  },
  "plunder-the-graves": {
    difficulty: 6,
    reason: "Balanced complexity with accessible gameplay and fun interactions."
  },
  "plunder-the-graves-2015": {
    difficulty: 7,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "political-puppets": {
    difficulty: 6,
    reason: "Balanced complexity with accessible gameplay and fun interactions."
  },
  "power-hungry": {
    difficulty: 7,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "primal-genesis": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "princess-bride-1": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "prosper-tome-bound": {
    difficulty: 9,
    reason: "Advanced strategies with multiple decision points. Best for experienced players."
  },
  "quick-draw": {
    difficulty: 8,
    reason: "Storm-style gameplay requires sequencing multiple spells correctly for maximum value."
  },
  "rainbow-bridge": {
    difficulty: 7,
    reason: "Five-color legendary tribal requires managing many different effects."
  },
  "rat-colony": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "reap-the-tides": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "revenant-recon": {
    difficulty: 6,
    reason: "Surveil and reanimation are straightforward graveyard strategies."
  },
  "revival-trance": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "riders-of-rohan": {
    difficulty: 5,
    reason: "Simple tribal aggro strategy with Humans and Knights."
  },
  "ruinous-powers": {
    difficulty: 8,
    reason: "Cascade creates unpredictable gameplay that rewards experience."
  },
  "ruthless-regiment": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "scarecrow-reaper": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "science": {
    difficulty: 7,
    reason: "Managing energy counters and artifacts requires planning but offers powerful payoffs."
  },
  "scions-and-spellcraft": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "scrappy-survivors": {
    difficulty: 5,
    reason: "Straightforward Equipment and Aura strategy with clear paths to victory."
  },
  "seize-control": {
    difficulty: 9,
    reason: "Advanced strategies with multiple decision points. Best for experienced players."
  },
  "servo-city": {
    difficulty: 9,
    reason: "Advanced strategies with multiple decision points. Best for experienced players."
  },
  "shapeshifter-swarm": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "skeleton-crew": {
    difficulty: 6,
    reason: "Balanced complexity with accessible gameplay and fun interactions."
  },
  "sliver-swarm": {
    difficulty: 8,
    reason: "Five-color mana base and tracking all sliver abilities is complex."
  },
  "snake-basket": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "sphinx-wisdom": {
    difficulty: 6,
    reason: "Balanced complexity with accessible gameplay and fun interactions."
  },
  "spider-web": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "spirit-squadron": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "squirrel-mob": {
    difficulty: 7,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "squirreled-away": {
    difficulty: 5,
    reason: "Token strategies are straightforward - make lots of creatures and attack!"
  },
  "stalwart-unity": {
    difficulty: 6,
    reason: "Balanced complexity with accessible gameplay and fun interactions."
  },
  "stranger-things-1": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "street-fighter-1": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "street-fighter-2": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "subjective-reality": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "swell-the-host": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "sworn-to-darkness": {
    difficulty: 6,
    reason: "Balanced complexity with accessible gameplay and fun interactions."
  },
  "symbiotic-swarm": {
    difficulty: 6,
    reason: "Balanced complexity with accessible gameplay and fun interactions."
  },
  "temur-roar": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "the-ruinous-powers": {
    difficulty: 9,
    reason: "Advanced strategies with multiple decision points. Best for experienced players."
  },
  "timey-wimey": {
    difficulty: 9,
    reason: "Time manipulation and suspend require careful planning and timing."
  },
  "tinker-time": {
    difficulty: 9,
    reason: "Advanced strategies with multiple decision points. Best for experienced players."
  },
  "transformers-autobots": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "transformers-decepticons": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "treefolk-grove": {
    difficulty: 6,
    reason: "Balanced complexity with accessible gameplay and fun interactions."
  },
  "tricky-terrain": {
    difficulty: 8,
    reason: "Complex interactions between land types and creature types require careful tracking."
  },
  "tyranid-swarm": {
    difficulty: 6,
    reason: "Token swarm strategy is straightforward but powerful."
  },
  "undead-unleashed": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "uprising": {
    difficulty: 4,
    reason: "Aggressive creature deck with straightforward combat strategy."
  },
  "vampiric-bloodline": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "vampiric-bloodlust": {
    difficulty: 7,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "vehicle-squadron": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "veloci-ramp-tor": {
    difficulty: 5,
    reason: "Dinosaur tribal with vehicles is straightforward and fun to pilot."
  },
  "wade-into-battle": {
    difficulty: 4,
    reason: "Straightforward gameplay with clear win conditions. Great for beginners!"
  },
  "walking-dead-1": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "warhammer-orks": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "werewolf-pack": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "world-shaper": {
    difficulty: 6,
    reason: "Solid strategies that are easy to learn but offer room to grow your skills."
  },
  "zhulodok": {
    difficulty: 8,
    reason: "Copying expensive spells requires careful mana management and sequencing."
  },
};
